import { render, staticRenderFns } from "./CreateNewContract.vue?vue&type=template&id=8f086654&"
import script from "./CreateNewContract.vue?vue&type=script&lang=js&"
export * from "./CreateNewContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports